import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import yn from "yn";
import { useEnv } from "@RHCommerceDev/hooks/useEnv";

// List of allowed paths for guesthouse domain
const allowedGuesthousePaths = [
  "/",
  "/rooms",
  "/rooms/guestrooms",
  "/rooms/guestsuites",
  "/rooms/theresidence",
  "/content/rh/us/en/guesthouse/ghny-update-v2/inquire",
  "/inquire",
  "/diningroom",
  "/champagnecaviarbar",
  "/rooftop",
  "/error/not-found-error.jsp"
];

interface GuesthouseRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Restricts access to certain routes when on the rhguesthouse.com domain.
 * Navigates to /error/not-found-error.jsp if the current path is not allowed.
 */
export const GuesthouseRouteGuard: React.FC<GuesthouseRouteGuardProps> = ({
  children
}) => {
  const location = useLocation();
  const history = useHistory();
  const env = useEnv();
  const FORCE_GUESTHOUSE_MODE = yn(env?.FORCE_GUESTHOUSE_MODE);

  const stripCountryLocalePrefix = (pathname: string) => {
    // Match patterns like /us/en/... or /uk/fr/...
    const prefixRegex = /^\/[a-z]{2}\/[a-z]{2}(\/|$)/i;
    return pathname.replace(prefixRegex, "/");
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.host;
    if (host.includes("rhguesthouse") || FORCE_GUESTHOUSE_MODE) {
      const normalizedPath = stripCountryLocalePrefix(location.pathname);

      const isAllowed = allowedGuesthousePaths.some(
        path => normalizedPath === path || normalizedPath.startsWith(`${path}/`)
      );

      if (!isAllowed) {
        history.push("/error/not-found-error.jsp");
      }
    }
  }, [location.pathname, FORCE_GUESTHOUSE_MODE, history]);

  return <>{children}</>;
};
